import {Component} from '@angular/core';
import {AuthService, MessagesServices} from '../../api/';
import {Router} from '@angular/router';
import {ToastyService, ToastyConfig, ToastOptions} from 'ng2-toasty';

@Component({
    selector: 'app-forgot-screenname',
    templateUrl: './forgot-screenname.component.html',
    styleUrls: ['./forgot-screenname.component.css']
})
export class ForgotScreennameComponent {
    public email: string = '';
    private errorArray: Array<any> = [];
    private loading: boolean = false;
    private messages: any = new Array<any>();
    msg1: any = '';
    title1: any = '';
    msg2: any = '';
    title2: any = '';

    constructor(private authService: AuthService, private sm: MessagesServices, private router: Router, private toastyService: ToastyService,
    private toastyConfig: ToastyConfig) {
        //getting messages from db
        this.messages = this.sm.messags;
        this.setMessages();
    }

    /**
     * setting system messages
     **/
    setMessages() {
        this.msg1 = '';
        this.title1 = '';
        if (this.messages) {
            for (var i = 0; i < this.messages.length; i++) {
                if (this.messages[i].event == 'WG_EVENT_EMAIL_WITH_SCREEN_NAME_SENT_SUCCESSFULLY') {
                    this.title1 = this.messages[i].title;
                    this.msg1 = this.messages[i].message;
                }
                if (this.messages[i].event == 'WG_EVENT_REQUEST_NOT_SUCCESSFULL') {
                    this.title2 = this.messages[i].title;
                }
            }
        }
    }

    sendScreennameResetRequest() {
        this.loading = true;
        let toastOptions: ToastOptions = {
            title: this.title1,
            showClose: true,
            timeout: 2000,
            theme: 'default'
        };
        this.authService.sendScreennameresetRequest(this.email).subscribe((res) => {
            let data = res.json();
            if (data.code === 200) {
                toastOptions.msg = this.msg1;
                this.toastyService.success(toastOptions);
                this.router.navigate(['/login']);
            } else {
                this.errorArray['message'] = 'Your email is not found in our system.';
            }
            this.loading = false;
        }, (err) => {
            toastOptions.title = this.title2;
            this.toastyService.error(toastOptions);
            this.handleErrors(err);
            this.loading = false;
        });
    }

    handleErrors(err: any) {
        this.errorArray = [];
        let validationErrors = JSON.parse(err._body);
        if (err._body) {
            for (let index = 0; index < validationErrors.length; index++) {
                this.errorArray[validationErrors[index].field] = validationErrors[index].message;
            }
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/user/forgot-screenname/forgot-screenname.component.ts